import { render, staticRenderFns } from "./eventAnalysis.vue?vue&type=template&id=37479ea8&"
import script from "./eventAnalysis.vue?vue&type=script&lang=js&"
export * from "./eventAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37479ea8')) {
      api.createRecord('37479ea8', component.options)
    } else {
      api.reload('37479ea8', component.options)
    }
    module.hot.accept("./eventAnalysis.vue?vue&type=template&id=37479ea8&", function () {
      api.rerender('37479ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/eventAnalysis.vue"
export default component.exports